import React from 'react';
import Main from './Main.js';
import Header from './Header.js';
import Footer from './Footer.js';
const Layout = () => {
	return (
		<>
			<Header/>
			<Main/>
			<Footer/>
		</>
	)
}

export default Layout